import React from 'react';
import Modal from '../Modal/Modal';
import styles from './CampaignModal.module.css';

const CampaignModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles["campaign-modal"]}>
        <div className={styles["campaign-header"]}>
          <h2 className={styles["campaign-title"]}>Kickstarter Campaign</h2>
          <p className={styles["campaign-subtitle"]}>Join us in bringing LifeInPXL to life</p>
        </div>

        <div className={styles["campaign-image"]}>
          <img 
            src="https://images.unsplash.com/photo-1558655146-364adaf1fcc9?w=600&h=400&fit=crop" 
            alt="Kickstarter campaign" 
            className={styles["campaign-img"]}
          />
        </div>

        <div className={styles["campaign-content"]}>
          <div className={styles["campaign-section"]}>
            <h3 className={styles["section-title"]}>Early Bird Special</h3>
            <p className={styles["section-text"]}>
              Be among the first to get LifeInPXL at an exclusive early bird price. 
              Limited spots available for our first production batch.
            </p>
          </div>

          <div className={styles["campaign-section"]}>
            <h3 className={styles["section-title"]}>What You Get</h3>
            <ul className={styles["benefits-list"]}>
              <li>✓ LifeInPXL e-ink frame</li>
              <li>✓ Free mobile app for photo sync</li>
              <li>✓ 1-year warranty</li>
              <li>✓ Priority shipping</li>
              <li>✓ Exclusive Kickstarter updates</li>
            </ul>
          </div>

          <div className={styles["campaign-section"]}>
            <h3 className={styles["section-title"]}>Launch Date</h3>
            <p className={styles["section-text"]}>
              Our Kickstarter campaign launches on <strong>December 16th</strong>. 
              Sign up below to get notified the moment we go live!
            </p>
          </div>

          <div className={styles["campaign-cta"]}>
            <button className={styles["notify-button"]} onClick={onClose}>
              Get Notified
            </button>
            <p className={styles["cta-note"]}>
              We'll send you an email when the campaign goes live
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CampaignModal;

